/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { Highlight } from 'ui/atoms/Highlight/Highlight';
import { Image } from 'ui/atoms/Image';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './EnrichmentProofSection.module.scss';

const MORE_CUSTOMERS = [
  {
    name: 'Statista',
    href: 'https://www.globaldatabase.com/how-statista-enriches-its-company-data-product-with-global-database',
  },
  {
    name: 'Menzies LLP',
    href: 'https://www.globaldatabase.com/menzies-llp-enhancing-crm-with-detailed-financial-data-via-api-integration',
  },
  {
    name: 'Experian',
    href: 'https://www.globaldatabase.com/experian-enhances-benelux-company-data-coverage-with-global-database-partnership',
  },
] as const;

export const EnrichmentProofSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(true);
          io.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Section
      background="#F6F7F9"
      extra={
        <Highlight color="blue" font="mono" uppercase>
          Customer stories
        </Highlight>
      }
    >
      <div ref={ref} className={cn(styles.root, revealed && styles.revealed)}>
        <div className={styles.logo}>
          <Image width={150} height={34} src="img/customers/schneider.svg" alt="Schneider Electric" />
        </div>

        <TitleBlock
          title="Schneider Electric mapped 600K companies across the UK and Ireland."
          className={styles.leadBlock}
        />

        <a
          className={styles.cta}
          href="https://www.globaldatabase.com/schneider-electric-uses-global-database-to-map-63m-companies-and-never-miss-a-sales-opportunity"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read the case study <span aria-hidden="true">→</span>
        </a>

        <div className={styles.more}>
          <span className={styles.moreK}>Also in production at</span>

          <div className={styles.moreLogos}>
            {MORE_CUSTOMERS.map((c) => (
              <a key={c.name} href={c.href} target="_blank" rel="noopener noreferrer" className={styles.moreLink}>
                {c.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};
